<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="benefitForm">
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-layout row wrap>
          <v-flex xs6  v-if="!newBenefit">
            <v-subheader class="queryLabel">{{labels.benefitQuery}}</v-subheader>
            <div class="title">{{benefitForm.benefit}} - {{benefitForm.benefitDesc}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete data-vv-scope="benefitForm" :items="benefitList" v-model="benefitForm.benefit" :label="labels.benefit" item-text="label" item-value="value" :error-messages="errors.collect('benefitForm.benefit')" data-vv-name="benefit" :data-vv-as="labels.benefit" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="benefitForm" v-model="benefitForm.napSubLevel" :label="labels.napSubLevel" :error-messages="errors.collect('benefitForm.napSubLevel')" data-vv-name="napSubLevel" :data-vv-as="labels.napSubLevel" v-validate="'required|numeric|max:10'"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!newBenefit">
            <cal-picker data-vv-scope = "benefitForm" :label="labels.effDate" v-model="benefitForm.effDate" :error-messages="errors.collect('benefitForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'" readonly></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker data-vv-scope = "benefitForm" :label="labels.effDate" v-model="benefitForm.effDate" :error-messages="errors.collect('benefitForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <cal-picker data-vv-scope = "benefitForm" :label="labels.expDate" v-model="benefitForm.expDate" :error-messages="errors.collect('benefitForm.expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate" :min="benefitForm.effDate"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <v-autocomplete data-vv-scope="benefitForm" :items="benTypeList" v-model="benefitForm.benType" :label="labels.benType" item-text="label" item-value="value" :error-messages="errors.collect('benefitForm.benType')" data-vv-name="benType" :data-vv-as="labels.benType" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-autocomplete data-vv-scope="benefitForm" :items="gapCalcMethodList()" v-model="benefitForm.gapCalcMethod" :label="labels.gapCalcMethod" item-text="label" item-value="value" :error-messages="errors.collect('benefitForm.gapCalcMethod')" data-vv-name="gapCalcMethod" :data-vv-as="labels.gapCalcMethod" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs4>
            <v-checkbox data-vv-scope = "benefitForm" :label="labels.addBen" v-model="benefitForm.addBen"></v-checkbox>
          </v-flex>
          <v-flex xs4>
            <v-checkbox data-vv-scope = "benefitForm" :label="labels.defBen" v-model="benefitForm.defBen"></v-checkbox>
          </v-flex>
          <v-flex xs4>
            <v-checkbox data-vv-scope = "benefitForm" :label="labels.protSi" v-model="benefitForm.protSi"></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="benefitForm" v-model="benefitForm.minSi" v-num-mask="{negative: true, intScale: 18}" :label="labels.minSi" :error-messages="errors.collect('benefitForm.minSi')" data-vv-name="minSi" :data-vv-as="labels.minSi" v-validate="maxValidation(benefitForm.maxSi)"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="benefitForm" v-model="benefitForm.maxSi" v-num-mask="{negative: true, intScale: 18}" :label="labels.maxSi" :error-messages="errors.collect('benefitForm.maxSi')" data-vv-name="maxSi" :data-vv-as="labels.maxSi" v-validate="minValidation(benefitForm.minSi)"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="benefitForm" v-model="benefitForm.basedUom" :label="labels.basedUom" :error-messages="errors.collect('benefitForm.basedUom')" data-vv-name="basedUom" :data-vv-as="labels.basedUom" v-validate="'required|numeric|max:10'"></v-text-field>
          </v-flex>
        </v-layout>
      </form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveBenefitForm">
        {{newBenefit ? 'Save Benefit' : 'Update Benefit'}}
        <v-icon right>{{newBenefit ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
import { mtrGapCalcMethod } from '@/const/underwriting/motor'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { removeFormatNumber, formatDisplayNumber } from '@/utils/number.js'
import { BenefitType } from '@/const/params'
export default {
  data() {
    return {
      labels: {
        benefit: 'Benefit*',
        benefitQuery: 'Benefit',
        gapCalcMethod: 'GAP Calculation Method*',
        benType: 'Benefit Type*',
        napSubLevel: 'NAP Sub Level*',
        addBen: 'Add Benefit',
        defBen: 'Default Benefit',
        minSi: 'Minimum Sum Insured',
        maxSi: 'Maximum Sum Insured',
        protSi: 'Protect Sum Insured',
        basedUom: 'Based Unit Of Measure*',
        expDate: 'Expired Date',
        effDate: 'Effective Date*'
      },
      benefitForm: {
        benefit: null,
        benefitDesc: null,
        gapCalcMethod: null,
        benType: null,
        benTypeDesc: null,
        napSubLevel: 0,
        addBen: false,
        defBen: false,
        minSi: 0,
        maxSi: 0,
        protSi: false,
        basedUom: 0,
        expDate: null,
        effDate: null
      },
      benTypeList: [],
      benefitList: [],
      loading: false,
      submitting: false,
      newBenefit: null,
      menu: []
    }
  },
  watch: {
    'ids.benefit': function (value) {
      if (value !== 'new') {
        this.resetValidator()
        this.resetMessages()
        this.newBenefit = false
        this.fetchForm(value)
      } else {
        this.newBenefit = true
        this.doClearForm()
        Promise.all([this.doBenefitInit(), this.benTypeListInit()])
      }
    },
    'tarfBenForm.minSi': function (value) {
      this.minValidation(value)
    }
  },
  computed: {
    busClsTariffMenu() {
      return this.$store.state.parameters.busCls.tariff.menu
    }
  },
  methods: {
    minValidation(value) {
      const min = removeFormatNumber(value)
      return 'mask_min_value:' + min
    },
    maxValidation(value) {
      const max = removeFormatNumber(value)
      return 'mask_max_value:' + max
    },
    async fetchForm(benefit) {
      const apiURI = this.busClsTariffMenu.tarfBenGet
      if (apiURI) {
        try {
          const expand = {
            busCls: this.ids.busCls,
            tarf: this.ids.tarf,
            benefit: benefit,
            effDate: this.ids.benEffDate
          }
          await this.benTypeListInit()
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.benefitForm.tarf = this.ids.tarf
            this.benefitForm.busCls = this.ids.busCls
            this.benefitForm.benefit = data.tarfBen.benefit
            this.benefitForm.benefitDesc = data.tarfBen.benefitDesc
            this.benefitForm.gapCalcMethod = data.tarfBen.gapCalcMethod
            this.benefitForm.benType = data.tarfBen.benType
            this.benefitForm.benTypeDesc = data.tarfBen.benTypeDesc
            this.benefitForm.napSubLevel = data.tarfBen.napSubLevel
            this.benefitForm.addBen = data.tarfBen.addBen
            this.benefitForm.defBen = data.tarfBen.defBen
            this.benefitForm.minSi = formatDisplayNumber(data.tarfBen.minSi)
            this.benefitForm.maxSi = formatDisplayNumber(data.tarfBen.maxSi)
            this.benefitForm.protSi = data.tarfBen.protSi
            this.benefitForm.basedUom = data.tarfBen.basedUom
            this.benefitForm.expDate = data.tarfBen.expDate
            this.benefitForm.effDate = data.tarfBen.effDate

            this.menu = extractMenu(result.data._links)
          }
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doBenefitInit() {
      const apiURI = this.busClsTariffMenu.benefitList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          if (this.benefitList.length > 0) {
            this.benefitList = []
          }
          this.benefitList = data.benefitList
        } else {
          this.benefitList = []
        }
      }
    },
    async benTypeListInit() {
      const list = Object.freeze(BenefitType)
      this.benTypeList = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    gapCalcMethodList() {
      const list = Object.freeze(mtrGapCalcMethod)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.benefitForm.tarf = this.ids.tarf
      this.benefitForm.busCls = this.ids.busCls
      this.benefitForm.benefit = null
      this.benefitForm.benefitDesc = null
      this.benefitForm.gapCalcMethod = null
      this.benefitForm.benType = null
      this.benefitForm.benTypeDesc = null
      this.benefitForm.napSubLevel = 0
      this.benefitForm.addBen = false
      this.benefitForm.defBen = false
      this.benefitForm.minSi = 0
      this.benefitForm.maxSi = 0
      this.benefitForm.protSi = false
      this.benefitForm.basedUom = 0
      this.benefitForm.expDate = null
      this.benefitForm.effDate = null
    },
    doSaveBenefitForm() {
      this.resetMessages()
      this.$validator.validateAll('benefitForm').then(result => {
        if (result) {
          if (this.newBenefit) {
            this.doCreateBenefitForm()
          } else {
            this.doUpdateBenefitForm()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateBenefitForm() {
      const apiURI = this.busClsTariffMenu.tarfBenCreate
      if (apiURI) {
        try {
          const formatForm = {
            tarf: this.ids.tarf,
            busCls: this.ids.busCls,
            benefit: this.benefitForm.benefit,
            benefitDesc: this.benefitForm.benefitDesc,
            gapCalcMethod: this.benefitForm.gapCalcMethod,
            benType: this.benefitForm.benType,
            benTypeDesc: this.benefitForm.benTypeDesc,
            napSubLevel: this.benefitForm.napSubLevel,
            addBen: this.benefitForm.addBen,
            defBen: this.benefitForm.defBen,
            minSi: removeFormatNumber(this.benefitForm.minSi),
            maxSi: removeFormatNumber(this.benefitForm.maxSi),
            protSi: this.benefitForm.protSi,
            basedUom: this.benefitForm.basedUom,
            expDate: this.benefitForm.expDate,
            effDate: this.benefitForm.effDate
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClearForm()
            this.$emit('resetTab', 2)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doUpdateBenefitForm() {
      const apiURI = this.menu.tarfBenUpdate
      this.sumbitting = true
      if (apiURI) {
        try {
          const formatForm = {
            tarf: this.benefitForm.tarf,
            busCls: this.benefitForm.busCls,
            benefit: this.benefitForm.benefit,
            benefitDesc: this.benefitForm.benefitDesc,
            gapCalcMethod: this.benefitForm.gapCalcMethod,
            benType: this.benefitForm.benType,
            benTypeDesc: this.benefitForm.benTypeDesc,
            napSubLevel: this.benefitForm.napSubLevel,
            addBen: this.benefitForm.addBen,
            defBen: this.benefitForm.defBen,
            minSi: removeFormatNumber(this.benefitForm.minSi),
            maxSi: removeFormatNumber(this.benefitForm.maxSi),
            protSi: this.benefitForm.protSi,
            basedUom: this.benefitForm.basedUom,
            expDate: this.benefitForm.expDate,
            effDate: this.benefitForm.effDate
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.sumbitting = false
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.sumbitting = false
        }
      } else {
        this.errorMessage('Invalid API Url')
        this.sumbitting = false
      }
    }
  },
  mounted() {
    if (this.newBenefit) {
      this.doClearForm()
    }
    Promise.all([this.doBenefitInit(), this.benTypeListInit()])
  },
  props: {
    ids: {
      type: Object,
      default () {
        return {
          busCls: null,
          tarf: null,
          benefit: null,
          benEffDate: null
        }
      }
    }
  },
  mixins: [
    FieldMixin,
    MessageMixin
  ]
}
</script>

<style>

</style>
